import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { Loader2 } from 'lucide-react';

/** Restaurant staff routes: requires a tenant user with a linked venue (not platform admin). */
export default function TenantProtectedRoute({ children }) {
  const { loading, isAuthenticated, isTenantUser, isPlatformAdmin, pinPending } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAuthenticated) {
    if (pinPending) {
      return <Navigate to="/admin/pin-login" state={{ from: location }} replace />;
    }
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (isPlatformAdmin) {
    return <Navigate to="/platform/dashboard" replace />;
  }

  if (!isTenantUser) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
